import { Card, CardContent, CardHeader, Skeleton } from '@mui/material';
import { ChartContent } from './ChartContent';

const cardHeaderStyle = {
  borderBottom: 1,
  borderColor: 'divider',
  pt: 1.25,
  px: 2.5,
  pb: 0.625,
} as const;

export const TitleChart = () => {
  return (
    <Card elevation={2}>
      <CardHeader sx={cardHeaderStyle} title={<Skeleton variant="rectangular" width={100} height={14} sx={{ my: 1.125 }} />} />
      <CardContent sx={{ pt: 1 }}>
        <ChartContent />
      </CardContent>
    </Card>
  );
};
